import { onDocumentEvent } from '@app/utils/domHelpers'

const toggleSubAdjustments = (e) => {
  e.preventDefault()
  const subAdjustmentElementSelector = e.target.getAttribute('href')
  const subAdjustmentElement = document.querySelector(
    subAdjustmentElementSelector
  )

  if (subAdjustmentElement) {
    const currentDisplay = subAdjustmentElement.style.display
    subAdjustmentElement.style.display =
      currentDisplay === 'none' ? 'block' : 'none'
  }
}

const showSubAdjustmentsIfPresent = () => {
  if (window.location.hash !== '#show_adjustments') {
    return
  }

  const subAdjustmentElement = document.querySelector('#sub_adjustments')

  if (subAdjustmentElement) {
    subAdjustmentElement.style.display = 'block'
  }
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="toggle-adjustments-table"]',
  toggleSubAdjustments
)

onDomLoad(() => {
  showSubAdjustmentsIfPresent()
})
